
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ModalPortal from './ModalPortal.vue';
import ScrollView from '../ScrollView/ScrollView.vue';
import CloseIcon from '../../Icons/CloseIcon.vue';
import { Row, Column } from '../Grid';
import WebText from '../Text/Text.vue';

/**
 * Full Page Modal Component.
 *
 * Modal with full width and height.
 */
export default Vue.extend({
  name: 'FullPageModal',
  components: {
    ModalPortal,
    WebText,
    CloseIcon,
    Row,
    ScrollView
  },
  props: {
    /**
     * Open / active state of modal.
     */
    active: {
      type: Boolean,
      default: false,
      required: true
    },
    /**
     * ID of HTML modal.
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Title of the Header Modal.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Background color of the Header Modal.
     */
    backgroundColor: {
      type: String,
      default: '#ff6a00'
    },
    /**
     * Close icon color of the Header Modal.
     */
    closeButtonColor: {
      type: String,
      default: '#fff'
    },
    /**
     * Text variant of the title Header Modal.
     */
    titleVariant: {
      type: String,
      default: 'ui-baseline'
    },
    /**
     * Text ink of the title Header Modal.
     */
    titleInk: {
      type: String,
      default: 'white'
    },
    /**
     * Make title bold in Header Modal.
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Create straight line after Header Modal.
     */
    border: {
      type: Boolean,
      default: false
    },
    /**
     * Show header of the Modal.
     */
    needHeader: {
      type: Boolean,
      default: false
    },
    /**
     * Show close icon on the top right Modal.
     */
    closeIconRight: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      /**
       * Handle when modal is closed
       * @event close
       * @type {function}
       */
      this.$emit('close');
    }
  }
});
